export const calendarIcon = <img src={require('@/assets/images/calendar.png')} alt="calendar" className="img-s20" />;
export const searchIcon = (
    <img src={require('@/assets/images/search-icon.png')} alt="search-icon" className="img-s20" />
);
export const selectIcon = (
    <img src={require('@/assets/images/select-icon.png')} alt="select-icon" className="img-s20" />
);
